module.exports = __webpack_public_path__ + "img/logo.5799a6b5.png";